import React from 'react';

// Config
import { BERKLEY_BIG_BASS_LEADER_DESCRIPTION, BIG_BASS_LEADER_DESCRIPTION } from '../../config';

const berkleyBigBassTid = 1356;

interface IBigBassLeaderDescriptionType {
  tid?: number;
}

const BigBassLeaderDescription = (props: IBigBassLeaderDescriptionType) => {
  const {tid} = props;

  return (
    <span className="big-bass-leader__description">
      {tid === berkleyBigBassTid ? BERKLEY_BIG_BASS_LEADER_DESCRIPTION : BIG_BASS_LEADER_DESCRIPTION }
    </span>
  );
}



export default BigBassLeaderDescription;
